ui-cms-superteaser {
  --bg-small: 380px;
  --bg-small-tablet: 300px;
  --bg-medium: 500px;
  --bg-large: 820px;
  --text-shadow: 0 0 12px rgb(24 24 24 / 50%);

  display: block;
  width: 100%;

  .sr-only {
    @include sr-only;
  }

  ui-cms-image img {
    height: 100%;
    object-fit: cover;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  sd-button {
    padding-top: $sd-spacing-4;
  }

  .sd-copyright {
    height: 100%;

    &::after {
      top: 0;
      bottom: unset;
      padding: $sd-spacing-2 $sd-spacing-4 0 0;
      text-align: right;
    }

    &--color {
      &-white {
        &::after {
          color: $sd-textColor-white;
        }
      }

      &-black {
        &::after {
          color: $sd-textColor-black;
        }
      }
    }
  }

  .st {
    position: relative;
    container-type: inline-size;

    &--bs-orientation {
      &-behind-text {
        &.st--text-position {
          &-left-center {
            &.st--bs-color-white .st__bs {
              &::part(shape-middle),
              &::part(shape-top),
              &::part(shape-bottom) {
                opacity: 0.9;
              }
            }

            .st__content {
              padding-top: 0;
            }

            .st__bs {
              position: relative;

              &::part(shape-middle),
              &::part(shape-top),
              &::part(shape-bottom) {
                opacity: 0.8;
              }
            }
          }

          &-left-bottom,
          &-center-bottom {
            .st__content {
              padding: 0 0 $sd-spacing-6 $sd-spacing-4;
              background-color: $sd-backgroundColor-white;
            }
          }
        }

        &.st--bs-color {
          &-white {
            .st__content {
              background-color: $sd-backgroundColor-neutral-200;
            }
          }
        }
      }

      &-behind-claim {
        .st__bs {
          &::part(shape-middle),
          &::part(shape-top),
          &::part(shape-bottom) {
            opacity: 0.8;
          }
        }
      }
    }

    &--bs-color {
      &-primary {
        .st__content {
          background-color: $sd-backgroundColor-white;
        }

        .st__bs {
          .sd-headline,
          .sd-paragraph {
            color: $sd-textColor-white;
          }
        }
      }

      &-white {
        .st__content {
          background-color: $sd-backgroundColor-white;
        }
      }
    }

    &__background {
      position: relative;
    }

    &__image {
      aspect-ratio: 4 / 3;
      text-shadow: var(--text-shadow);

      &--mobile-aspect-ratio-square {
        aspect-ratio: 1;
      }
    }

    &__content {
      padding: $sd-spacing-6 $sd-spacing-4;
    }

    &__bs {
      &::part(shape-middle),
      &::part(shape-top),
      &::part(shape-bottom) {
        opacity: 1;
      }
    }

    &__claim {
      position: absolute;
      right: 0;
      left: 0;
      bottom: 0;
      padding-right: $sd-spacing-4;
    }

    &__claim-text {
      display: none;
      padding-bottom: $sd-spacing-4;
    }

    &__overline {
      color: $sd-textColor-primary-DEFAULT;
    }

    &__subline {
      padding-top: $sd-spacing-4;
      color: $sd-textColor-black;
    }

    &__quotation {
      text-align: left;

      .sd-headline,
      .sd-paragraph {
        color: $sd-textColor-primary-DEFAULT;
      }

      &--handwriting {
        font-family: $font-family-handwriting;
      }

      q {
        display: block;
        margin-bottom: $sd-spacing-6;
      }

      &-author {
        font-weight: $sd-fontWeight-bold;
      }

      &-subtitle {
        font-weight: $sd-fontWeight-bold;
      }
    }
  }

  @container ( min-width: #{$small}) {
    .st {
      &--bs-orientation-behind-text {
        &.st--text-position {
          &-left-bottom,
          &-center-bottom {
            &.st--bs-color-white .st__bs {
              &::part(shape-middle),
              &::part(shape-top),
              &::part(shape-bottom) {
                opacity: 0.9;
              }
            }

            .st__bs {
              &::part(shape-middle),
              &::part(shape-top),
              &::part(shape-bottom) {
                opacity: 0.8;
              }
            }

            .st__content {
              position: absolute;
              bottom: 0;
              padding: 0 0 0 $sd-spacing-8;
              background-color: transparent;
            }
          }

          .st__content {
            padding: $sd-spacing-6 $sd-spacing-8;
          }
        }
      }

      &__image {
        aspect-ratio: unset;
        height: 100%;
      }

      &__background {
        height: var(--bg-small);
      }

      &__content-wrapper {
        width: 512px;
      }
    }
  }

  @container (min-width: #{$medium}) {
    .st {
      &--variant {
        &-small {
          .st__background {
            height: var(--bg-small-tablet);
          }
        }

        &-medium,
        &-large {
          .st__background {
            height: var(--bg-medium);
          }
        }
      }

      &--bs-orientation {
        &-behind-claim {
          .st__claim-text {
            display: block;
            padding-bottom: 0;
          }
        }
      }

      &--bs-color {
        &-primary {
          .st__claim-text {
            color: $sd-textColor-white;
          }
        }

        &-white {
          .st__claim-text {
            color: $sd-textColor-black;
          }
        }
      }

      &__content {
        padding: $sd-spacing-6 $sd-spacing-8;
      }
    }
  }

  @container (min-width: #{$desktop}) {
    .st {
      &--bs-orientation {
        &-behind-text {
          &.st--text-position {
            &-left-bottom,
            &-center-bottom {
              .st__content {
                padding: 0 0 0 $sd-spacing-8;
                width: 100%;
              }
            }
          }
        }

        &-behind-claim {
          .st__bs {
            width: 880px;
            margin-left: auto;
          }
        }

        &-hide {
          .st__claim-text {
            width: 43%;
          }
        }
      }

      &__content {
        padding: $sd-spacing-6 $sd-spacing-8;
      }

      &__content-wrapper {
        width: 43%;
      }

      &__claim {
        padding-right: $sd-spacing-8;
      }
    }
  }

  @container (min-width: #{$xlarge}) {
    .st {
      &--variant {
        &-large {
          .st__background {
            height: var(--bg-large);
          }
        }

        &-large,
        &-medium {
          .st__content {
            padding: 0;
          }
        }
      }

      &--text-position {
        &-left-bottom {
          &.st--variant {
            &-large,
            &-medium {
              .st__content {
                top: unset;
                padding: $sd-spacing-8 0;
              }
            }
          }
        }
      }

      &--bs-orientation {
        &-behind-text {
          &.st--bs-color {
            &-white,
            &-primary {
              .st__content {
                background-color: transparent;
              }
            }
          }

          &.st--text-position {
            &-left-center {
              .st__content {
                padding: 0;
              }

              .st__bs {
                position: static;
              }
            }

            &-left-bottom {
              &.st--variant {
                &-large,
                &-medium {
                  .st__content {
                    top: unset;
                    padding: 0;
                  }
                }
              }
            }

            &-center-bottom {
              .st__content {
                top: unset;
                padding: 0;
              }

              .st__content-wrapper {
                margin: auto;
              }

              .st__bs {
                text-align: center;
              }

              .sd-headline {
                display: block;
              }
            }
          }
        }

        &-hide,
        &-behind-text {
          &.st--text-color {
            &-primary {
              .st__claim-text {
                color: $sd-textColor-black;
              }
            }

            &-white {
              .st__claim-text {
                color: $sd-textColor-white;
              }
            }
          }
        }

        &-hide,
        &-behind-claim {
          &.st--text-position-right-center {
            .st__content-wrapper {
              margin-left: auto;
            }
          }

          .st__content {
            background-color: transparent;
          }

          &.st--text-color {
            &-white {
              .st__content {
                .sd-headline,
                .sd-paragraph {
                  color: $sd-textColor-white;
                }
              }
            }
          }
        }
      }

      &--text-shadow {
        .st__background,
        .st__content {
          text-shadow: var(--text-shadow);

          .st__bs {
            text-shadow: none;
          }
        }
      }

      &__content {
        display: flex;
        flex-direction: column;
        position: absolute;
        inset: 0;
        max-width: $xlarge;
        margin: auto;
        padding: 0;
      }

      &__content-wrapper {
        margin: auto 0;
        width: 560px;
      }

      &__bs {
        width: 100%;
      }

      &__claim {
        right: 0;
        bottom: 0;
        max-width: $xlarge;
        margin: auto;
        padding: 0;
      }

      &__claim-text {
        width: 560px;
        display: block;
        margin-left: auto;
      }
    }
  }
}
